"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { CpslButton, CpslIcon, CpslQrCode, CpslSpinner, CpslText } from "@getpara/react-components";
import { CenteredText, Heading, InnerStepContainer, QRContainer, StepContainer } from "../common.js";
import { useModalStore, useThemeStore, useUserInfoStore } from "../../stores/index.js";
import { ModalStep } from "../../utils/steps.js";
import { AuthMethod, isMobile } from "@getpara/web-sdk";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
import { useSetLoginURLs } from "../../hooks/useSetLoginURLs.js";
const FarcasterOAuthStep = () => {
  const setAuthInfo = useUserInfoStore((state) => state.setAuthInfo);
  const setStep = useModalStore((state) => state.setStep);
  const setWebAuthURLForCreate = useModalStore((state) => state.setWebAuthURLForCreate);
  const setIFrameUrl = useModalStore((state) => state.setIFrameUrl);
  const setIsIFrameReady = useModalStore((state) => state.setIsIFrameReady);
  const setAuthStepRoute = useModalStore((state) => state.setAuthStepRoute);
  const setBiometricLocationHints = useModalStore((state) => state.setBiometricLocationHints);
  const para = useInternalClient();
  const setFlow = useModalStore((state) => state.setFlow);
  const farcasterConnectUri = useModalStore((state) => state.farcasterConnectUri);
  const setFarcasterConnectUri = useModalStore((state) => state.setFarcasterConnectUri);
  const theme = useThemeStore((state) => state.theme);
  const setLoginURLs = useSetLoginURLs();
  useEffect(() => {
    if (farcasterConnectUri) {
      const pollStatus = () => __async(void 0, null, function* () {
        const { userExists, username, pfpUrl } = yield para.waitForFarcasterStatus();
        setAuthInfo({ farcasterUsername: username, pfpUrl });
        if (userExists) {
          const supportedAuthMethods = yield para.initiateUserLoginV2({ farcasterUsername: username });
          if (supportedAuthMethods.size > 0) {
            const biometricLocationHints = supportedAuthMethods.has(AuthMethod.PASSKEY) ? yield para.getUserBiometricLocationHints() : [];
            yield setLoginURLs({ supportedAuthMethods, authType: "farcaster", displayName: username, pfpUrl });
            setFlow("login");
            setStep(ModalStep.BIOMETRIC_LOGIN);
            setBiometricLocationHints(biometricLocationHints);
            return;
          }
        }
        const supportedCreateAuthMethods = yield para.getSupportedCreateAuthMethods();
        setIsIFrameReady(false);
        setFlow("signUp");
        const supportsPasskey = supportedCreateAuthMethods.has(AuthMethod.PASSKEY);
        if (supportsPasskey) {
          setWebAuthURLForCreate(yield para.shortenLoginLink(yield para.getSetUpBiometricsURL({ authType: "farcaster" })));
          setStep(ModalStep.BIOMETRIC_CREATION);
        }
        if (supportedCreateAuthMethods.has(AuthMethod.PASSWORD)) {
          setIFrameUrl(yield para.shortenLoginLink(yield para.getSetupPasswordURL({ authType: "farcaster", theme })));
          setAuthStepRoute(supportsPasskey ? ModalStep.BIOMETRIC_CREATION : ModalStep.PASSWORD_CREATION);
        }
        return;
      });
      pollStatus();
      return () => {
        setFarcasterConnectUri(void 0);
      };
    }
  }, [farcasterConnectUri]);
  return /* @__PURE__ */ jsx(StepContainer, { $wide: true, children: isMobile() ? /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
    /* @__PURE__ */ jsx(CpslText, { weight: "medium", color: "secondary", children: `Don\u2019t have Farcaster` }),
    /* @__PURE__ */ jsxs(CpslButton, { as: "a", href: "https://link.warpcast.com/download-qr", target: "_blank", variant: "secondary", children: [
      /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: "linkExternal" }),
      `Get Farcaster`
    ] })
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: "Sign in using Farcaster" }),
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(CenteredText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Scan the QR code with your phone's camera to proceed." }),
      /* @__PURE__ */ jsx(QRContainer, { children: !farcasterConnectUri ? /* @__PURE__ */ jsx(CpslSpinner, { size: 100 }) : /* @__PURE__ */ jsx(CpslQrCode, { url: farcasterConnectUri }) })
    ] })
  ] }) });
};
var FarcasterOAuthStep_default = FarcasterOAuthStep;
export {
  FarcasterOAuthStep_default as default
};
